import { useTranslation } from "react-i18next";

const SupportFaqData = () => {
  const { t } = useTranslation();

  return [
    {
      question: t("faqs.supportQuestion1"),
      answer: [
        t("faqs.supportAnswer1.0"), 
        t("faqs.supportAnswer1.1"), 
        t("faqs.supportAnswer1.2"), 
        t("faqs.supportAnswer1.3"), 
        t("faqs.supportAnswer1.4"), 
        t("faqs.supportAnswer1.5"), 
        t("faqs.supportAnswer1.6"), 
        t("faqs.supportAnswer1.7"), 
        t("faqs.supportAnswer1.8"), 
    ],
    }
  ];
};

export default SupportFaqData;
